import React, { forwardRef } from "react";

import ItemStatus from "pianofunclub-crm/components/General/ItemStatus";

import SelectRow from "pianofunclub-shared/components/ListItems/SelectRow";
import type { SelectRowRef } from "pianofunclub-shared/components/ListItems/SelectRow";
import type { LoadAccountsForModal_query_profiles$data } from "pianofunclub-shared/relay/graphql/accounts/__generated__/LoadAccountsForModal_query_profiles.graphql";
import { combineNotes, schoolYearConverter } from "pianofunclub-shared/utils/converters";
import { getFullName } from "pianofunclub-shared/utils/extractors";

export type AccountModalItem = NonNullable<
  LoadAccountsForModal_query_profiles$data["profiles"]
>["edges"][number];

export interface AccountSelectRowProps {
  data: NonNullable<NonNullable<AccountModalItem>["node"]>;
  detailType: "TEACHER" | "PUPIL" | "TEACHER_AND_DAY" | undefined;
  initiallySelected: boolean;
  pressItemHandler: (
    data: NonNullable<NonNullable<AccountModalItem>["node"]>,
    label: string
  ) => void;
  schoolId: string | undefined;
  selectItemHandler: (
    data: NonNullable<NonNullable<AccountModalItem>["node"]>,
    label: string
  ) => void;
}

const AccountSelectRow = forwardRef<SelectRowRef, AccountSelectRowProps>((props, ref) => {
  const { data, detailType, initiallySelected, pressItemHandler, schoolId, selectItemHandler } =
    props;

  const fullNameOrEmail = data.user.firstName
    ? getFullName(data.user.firstName, data.user.lastName)
    : data.user.email;

  const notes = combineNotes(data.teacherNoteForStaff, data.staffNoteForTeacher);

  return (
    <SelectRow
      ref={ref}
      id={data.id}
      initiallySelected={initiallySelected}
      label={`${fullNameOrEmail}${
        detailType === "PUPIL" && data.school?.name && !schoolId ? ` • ${data.school.name}` : ""
      }${
        detailType === "PUPIL" && data.schoolYear !== null
          ? ` • ${schoolYearConverter(data.schoolYear)}`
          : ""
      }${
        detailType === "PUPIL" && data.primaryParent?.accountNumber
          ? ` • #${data.primaryParent.accountNumber}`
          : ""
      }`}
      onPressItem={() => pressItemHandler(data, fullNameOrEmail)}
      onSelect={() => selectItemHandler(data, fullNameOrEmail)}
      renderRightElement={() => (
        <ItemStatus
          isTransparent
          py={0}
          status={data.status}
          textProps={{
            fontFamily: "Poppins-Regular",
          }}
        />
      )}
      tooltipLabel={notes}
    />
  );
});

export default React.memo(AccountSelectRow);
